module.exports = "img/10.b3d34f.webp";